import { Component, Input, OnInit } from '@angular/core';
import { IFaqGroupItemDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-faq-item-viewer',
  templateUrl: './faq-item-viewer.component.html',
  styleUrls: ['./faq-item-viewer.component.css']
})
export class FaqItemViewerComponent implements OnInit {
  @Input() item: IFaqGroupItemDto;
  timestamp = new Date().getTime();

  constructor() { }

  ngOnInit() {
  }

}
